import DialerHome from './views/discador/DialerHome.vue';
export default DialerHome;
